var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalPedGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37.201mm",
    height: "63.868mm",
    viewBox: "0 0 37.201 63.868",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.149 -78.374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 67.149 79.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4.2676,
    width: 140.6,
    height: 241.39,
    ry: 44.816
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.1 -455.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1014.8,
    cy: 516.62,
    r: 44.596,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1014.8,
    cy: 628.02,
    r: 44.596,
    fill: "#0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 354.3 -39.018)",
    fill: "#280b0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1030.1 642.43 12.479-24.193-1.6302-3.7448-5.474 7.2031c-2.8802 2.4948-6.526-0.77083-4.224-3.6458l10.078-12.771c1.3437-1.7292 3.651-3.1667 4.7083-3.5521 1.3437-0.57292 2.3021-0.28645 3.7396 0.95833l9.6041 9.9844c0.3803 0.38541 0.474 0.29166 0.6719 1.25v6.2396c0 3.0729-5.0885 3.1667-5.2812 0v-4.9948l-3.2657-3.3542-0.6718 6.4271 9.6927 24.578c1.5416 4.224-3.7396 6.3333-5.7552 2.2083l-8.2552-20.833-10.948 21.12c-2.2083 3.9375-7.4843 0.86459-5.4687-2.8802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1017.2 592.9c2.3958 0 4.3177 2.0104 4.3177 4.3177 0 2.401-1.9219 4.3177-4.3177 4.3177-2.3073 0-4.224-1.9167-4.224-4.3177 0-2.3073 1.9167-4.3177 4.224-4.3177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalPedGreen);
export default __webpack_public_path__ + "static/media/signal_ped_green.2c6fc0d9924f1baf05818218ea8b2259.svg";
export { ForwardRef as ReactComponent };